import LoadElement from "../../classes/load/LoadElement";

export default class DistributedLoadElement extends LoadElement {
  constructor(id, name, force, lengthL1, lengthL2, parentID) {
    super(id, name, force, lengthL1, parentID);
    this.lengthL2 = lengthL2;
    this.classType="DistributedLoadElement";
  }
}
